export function ChatGptNotice() {
  return (
    <footer style={{ fontSize: 12, marginTop: 4 }}>
      <div>Results provided by ChatGPT and may be incorrect.</div>
    </footer>
  );
}
